
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Database } from '@/integrations/supabase/types';
import { reportError } from '@/utils/errorReporter';

export type Testimonial = Database['public']['Tables']['testimonials']['Row'];

const fetchTestimonials = async (): Promise<Testimonial[] | null> => {
    const { data, error } = await supabase
        .from('testimonials')
        .select('*')
        .eq('is_published', true)
        .order('created_at', { ascending: false });

    if (error) {
        console.error('Error fetching testimonials:', error);
        reportError('Homepage/Testimonials', error);
        return null;
    }
    return data;
};

export const useTestimonials = () => {
    return useQuery<Testimonial[] | null>({
        queryKey: ['testimonials'],
        queryFn: fetchTestimonials,
    });
};
